import React from 'react';
import { Row, Col, Glyphicon, Modal } from 'react-bootstrap';
import { Button } from '../../../form/FormControls.jsx';
import { addFromTab } from '../../../../util/util.jsx';
import { tryToDeleteDeal, clearLink } from '../store/deal.store';
import { connect } from 'react-redux';
import { loadDealCopy } from '@/store/allaround.store';
import { push } from 'react-router-redux';
import CompositeProductElement from './CompositeProductElement';
import RegNumberElement from './RegNumberElement';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import { List, Map } from 'immutable';
import trash from '@/../style/trashlight.png';
import duplicate from '@/../style/duplicatelight.png';

class PurchaseSaleElementClass extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.dealCopy = this.dealCopy.bind(this);
    this.state = { showModal: false, data: <div /> };
  }

  componentWillMount() {
    if (this.props) {
      this.setState({ data: this.createDisplayData(this.props) });
    }
  }

  componentWillReceiveProps(props) {
    if (props.dealCopy && props.dealCopy.get('dealType') == props.dealType) {
      this.props.navigateToDealCopyCreation();
    }
    if (props.data
      && (props.data != this.props.data || props.lock != this.props.lock)) {
      this.setState({ data: this.createDisplayData(props) });
    }
  }

  createDisplayData(props) {
    if (props.data) {
      const header = (productId, link, selected) => {
        const captionAddodResult =
          props.captionAddon && props.captionAddon(productId, link, selected);
        return (<Row>
          <Col
            xs={12}
            style={{ paddingTop: 5, paddingBottom: 5 }}
            className={captionAddodResult ? '' : 'hidden'}
          >
            {captionAddodResult}
          </Col>
          <Col
            xs={12}
            id={`header-${props.dealIdx}`}
            style={{ paddingTop: 5, paddingBottom: 5 }}
          >
            <div style={{ float: 'left' }} className={'deal-element-header'}>
              <RegNumberElement
                data={props.data} type={props.dealType} dealId={props.dealId}
              />
            </div>
          </Col>
        </Row>);
      };
      const footer = (atom, link, selected) =>
        (<Row>
          <Col xs={12}>
            {this.props.footerAddon ? this.props.footerAddon(atom, link, selected) : ''}
          </Col>
        </Row>);

      let products = props.data.get('products', new List());
      const originalProducts =
        props.originalData ? props.originalData.get('products', new List()) : undefined;
      if (products.size === 0) {
        products = products.push(new Map());
      }
      return (
        <Row
          id={`pr_deal_${props.dealIdx}`}
          className={`deal-list-row pr_deal_${props.dealType}`}

        >
          {products.map((elem, idx) => {
            if (props.withLinks) {
              return elem.get(`${props.dealType}Link`, new Map())
                .filter(l => !l.get('dontShowAtPLTab') && !l.get('hide'))
                .map((link, linkIdx) => {
                  const fullIdx = products.size * idx + linkIdx;
                  return (
                    <div>
                      <CompositeProductElement
                        transport={props.transport}
                        style={fullIdx > 0 ? { marginTop: '15px' } : {}}
                        header={fullIdx === 0 || props.withLinks ? header : undefined}
                        footer={fullIdx === products.size - 1 || props.withLinks ?
                          footer : undefined}
                        key={`product-${fullIdx}`}
                        data={props.data}
                        idx={fullIdx}
                        dealIdx={props.dealIdx}
                        elem={elem}
                        link={link}
                        dealType={props.dealType}
                        mode={props.mode}
                        handleSelected={props.handleSelected}
                        hideLinks={props.hideLinks}
                        alerts={props.alerts}
                        noStatus={props.noStatus}
                        disabled={props.disabled}
                        multiNodalQuantity={this.props.multiNodalQuantity}
                        originalData={originalProducts ? originalProducts.get(idx) : undefined}
                        allowUrl={this.props.allowUrl}
                        url={`/deals/${props.dealType}/${props.data.get('id')}${addFromTab()}`}
                      />
                    </div>);
                });
            }
            return (<CompositeProductElement
              transport={props.transport}
              header={idx === 0 ? header : undefined}
              footer={idx === props.data.get('products').size - 1 ? footer : undefined}
              key={`product-${idx}-${!!props.lock}`}
              data={props.data}
              multiNodalQuantity={this.props.multiNodalQuantity}
              idx={idx}
              dealIdx={props.dealIdx}
              elem={elem}
              dealType={props.dealType}
              mode={props.mode}
              handleSelected={props.handleSelected}
              hideLinks={props.hideLinks}
              alerts={props.alerts}
              noStatus={props.noStatus}
              disabled={props.disabled}
              originalData={originalProducts ? originalProducts.get(idx) : undefined}
              allowUrl={this.props.allowUrl}
              url={`/deals/${props.dealType}/${props.data.get('id')}${addFromTab()}`}
              isLast={products.size - 1 === idx}
              isFirst={idx === 0}
            />);
          })}

          {!props.noControlls ?
            <span className={`deal-list-controls deal-list-controls_${props.dealType}`}>
              {validateRoleConfig(['myDeals#2', 'allDeals#2'], this.props.data) ?
                <Button
                  bsStyle="link" onClick={this.dealCopy}
                >
                  <img src={duplicate} alt={'Duplicate'} title={'Duplicate'} />
                </Button>
                :
                <div />
              }
              {!(props.lock && props.lock.get('owner'))
              && validateRoleConfig(['myDeals#3', 'allDeals#3'], this.props.data) ?
                <Button
                  bsStyle="link" onClick={this.openModal}
                >
                  <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
                </Button>
                :
                ''
              }
              {
                props.lock && props.lock.get('owner')
                  ? <Button
                    bsStyle="link"
                  >
                    <Glyphicon
                      glyph="lock"
                      title={`Locked by ${props.lock.get('owner')}` +
                      ` at ${new Date(props.lock.get('timeOfLocking'))}`}
                    />
                  </Button>
                  : ''
              }
            </span>
            : ''}
        </Row>);
    }
    return <div />;
  }

  dealCopy(e) {
    e.stopPropagation();
    this.props.loadDealCopy(this.props.data.get('id'));
  }

  openModal(e) {
    e.stopPropagation();
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  yesButton() {
    this.props.tryToDeleteDeal(this.props.data.get('id'));
    this.setState({ showModal: false });
  }

  render() {
    return (<div>
      <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal}>
        <Modal.Body bsClass="modal-link-body">
          Are you sure you want to delete this {this.props.dealType ? this.props.dealType : 'deal'}?
        </Modal.Body>
        <Modal.Footer bsClass="modal-link-footer">
          <Button id="delete_yes" bsStyle="danger" onClick={this.yesButton}>Yes</Button>
          <Button id="delete_no" onClick={this.closeModal}>No</Button>
        </Modal.Footer>
      </Modal>
      {this.state.data}
    </div>);
  }
}

PurchaseSaleElementClass.propTypes = {
  data: React.PropTypes.object.isRequired,
  lock: React.PropTypes.object,
  tryToDeleteDeal: React.PropTypes.func,
  noControlls: React.PropTypes.bool,
  noStatus: React.PropTypes.bool,
  handleSelected: React.PropTypes.func,
  mode: React.PropTypes.string,
  col: React.PropTypes.number,
  validateAgainst: React.PropTypes.object,
  hideLinks: React.PropTypes.bool,
  dealIdx: React.PropTypes.number,
  dealId: React.PropTypes.oneOfType([
    React.PropTypes.number,
    React.PropTypes.string,
  ]),
  disabled: React.PropTypes.bool,
  dealType: React.PropTypes.string,
  originalData: React.PropTypes.object,
  roles: React.PropTypes.oneOfType([
    React.PropTypes.object,
    React.PropTypes.string,
  ]),
  navigateToDealCopyCreation: React.PropTypes.func,
  loadDealCopy: React.PropTypes.func,
  dealCopy: React.PropTypes.object,
  allowUrl: React.PropTypes.bool,
  captionAddon: React.PropTypes.func,
  footerAddon: React.PropTypes.func,
  withLinks: React.PropTypes.bool,
  multiNodalQuantity: React.PropTypes.number,
  transport: React.PropTypes.object,
};

PurchaseSaleElementClass.defaultProps = {
  allowUrl: true,
};

export default connect(
  (state) => ({
    roles: state.getIn(['session', 'roles'], new List()),
    dealCopy: state.getIn(['allaround', 'dealCopy']),
  }),
  (dispatch, props) => ({
    tryToDeleteDeal(id) {
      tryToDeleteDeal(dispatch, props.dealType, id);
    },
    navigateToDealCopyCreation() {
      clearLink(dispatch);
      dispatch(push(`/deals/${props.dealType}/new`));
    },
    loadDealCopy(sourceId) {
      loadDealCopy(dispatch, props.dealType, sourceId);
    },
  }))(PurchaseSaleElementClass);
